import moment from "moment/moment";
import { formatState } from "../../../../js/formatting";

const agentLicensesByState = (agentLicenses) => {
  if (!agentLicenses && !Array.isArray(agentLicenses)) {
    return agentLicenses;
  }

  return [...agentLicenses].sort((a, b) => {
    if (a?.state < b?.state) {
      return -1;
    }

    if (a?.state > b?.state) {
      return 1;
    }

    return 0;
  });
};

const generateLicensedStates = (agentLicenses) => {
  if (!agentLicenses && !Array.isArray(agentLicenses)) {
    return [];
  }

  return [
    ...new Map(
      agentLicenses.map((item) => {
        const state = formatState(item.state);
        return [state, { value: item.state, content: state }];
      })
    ).values(),
  ];
};

const filteredLicenses = (
  agentLicenses,
  filters,
  initialFilterState,
  status
) => {
  if (!agentLicenses && !Array.isArray(agentLicenses)) {
    return [];
  }

  const isStateSelected = initialFilterState.state !== filters.state;
  const isStatusSelected = initialFilterState.status !== filters.status;

  let returnArray = [...agentLicenses];

  if (!isStateSelected && !isStatusSelected) {
    return agentLicenses;
  }

  if (isStateSelected) {
    returnArray = returnArray.filter(
      (license) => license.state === filters.state
    );
  }

  if (isStatusSelected) {
    returnArray = returnArray.filter((license) => {
      return (
        generateTerminationDateStatusObject(license.terminationDate, status)
          .statusText === filters.status
      );
    });
  }

  return returnArray;
};

const generateTerminationDateStatusObject = (terminationDate, status) => {
  return terminationDate
    ? isLicenseExpired(terminationDate, status)
      ? {
          status: status.expired.status,
          statusText: status.expired.message,
        }
      : isLicenseAlmostExpired(terminationDate, status)
      ? {
          status: status.almostExpired.status,
          statusText: status.almostExpired.message,
        }
      : {
          status: status.default.status,
          statusText: status.default.message,
        }
    : {
        status: status.nA.status,
        statusText: status.nA.message,
      };
};

const generateLicenseStatuses = (agentLicenses, status) => {
  if (!agentLicenses && !Array.isArray(agentLicenses)) {
    return [];
  }

  return [
    ...new Map(
      agentLicenses.map((item) => {
        const statusText = generateTerminationDateStatusObject(
          item.terminationDate,
          status
        ).statusText;
        return [statusText, { value: statusText, content: statusText }];
      })
    ).values(),
  ];
};

const isLicenseExpired = (terminationDate) => {
  return terminationDate ? moment().isAfter(terminationDate) : false;
};

const isLicenseAlmostExpired = (terminationDate, status) => {
  return terminationDate
    ? moment(terminationDate)
        .subtract(status.warnForTimeQuantity, status.warnForTimeUnit)
        .isAfter(moment)
    : false;
};

export {
  agentLicensesByState,
  filteredLicenses,
  generateLicensedStates,
  generateLicenseStatuses,
  generateTerminationDateStatusObject,
  isLicenseExpired,
  isLicenseAlmostExpired,
};
